var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-connection-status-alert.ts
import { BaseQLClient } from "@adornis/baseql/client/baseqlClient.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BehaviorSubject, takeUntil } from "rxjs";
import "./translations.js";
var enableConnectionStatusAlert = new BehaviorSubject(true);
var XConnectionStatusAlert = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.blocking = false;
    this.showDuration = 3e3;
    this.isOnline = true;
    this.isShowing = false;
    this.enabled = new RXController(this, enableConnectionStatusAlert);
    this._translation = new TranslationController(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.setupConnectionStatus();
  }
  setupConnectionStatus() {
    BaseQLClient.isConnected().pipe(takeUntil(this.disconnected)).subscribe(async (isOnline) => {
      if (isOnline === void 0) {
        return;
      }
      if (!!isOnline === this.isOnline) {
        return;
      }
      this.isOnline = !!isOnline;
      this.isShowing = true;
      setTimeout(() => {
        this.isShowing = false;
      }, this.showDuration);
    });
  }
  styles() {
    return [
      ...super.styles(),
      {
        "@keyframes fadeIn": { "0%": { opacity: "0" }, "50%": { opacity: "1" }, "100%": { opacity: "1" } }
      }
    ];
  }
  render() {
    if (!this.enabled.value) {
      return nothing;
    }
    if (!this.isOnline && this.blocking) {
      return html`
        <div
          ${css({
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        "z-index": "10000"
      })}
        ></div>
        <x-flex
          center
          crossaxis-center
          ${css({
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        "z-index": "10000"
      })}
        >
          <x-flex
            center
            crossaxis-center
            padding="md"
            space="xl"
            ${css({
        "text-align": "center",
        width: "50%",
        height: "50%",
        "align-items": "center",
        background: this.colors.white,
        "border-radius": this.sizes.borderRadius
      })}
          >
            <x-icon ${css({ "font-size": "10em" })}>wifi_off</x-icon>
            <x-h2 ${css({ "font-size": "3em" })}
              >${this._translation.translate("connection-status-alert", "offline")}</x-h2
            >
            <x-text ${css({ "font-size": "1.5em", "line-height": "1.25em" })}>
              ${this._translation.translate("connection-status-alert", "offlineLong")} <br />
              ${this._translation.translate("connection-status-alert", "checkConnection")}
            </x-text>
          </x-flex>
        </x-flex>
      `;
    }
    if (this.isShowing) {
      return html`
        <x-flex
          space="sm"
          padding="md"
          horizontal
          center
          crossaxis-center
          ${css({
        position: "absolute",
        top: this.spacing.sm,
        right: this.spacing.sm,
        background: this.isOnline ? this.colors.tone["success"] : this.colors.tone["error"],
        "border-radius": this.sizes.borderRadius,
        animation: "fadeIn 1s cubic-bezier(0.3, 0.1, 0.3, 0.85)",
        "z-index": "10001"
      })}
        >
          <x-icon ${css({ "font-size": "1.25em", color: this.colors.white })}>
            ${this.isOnline ? "check" : "warning"}
          </x-icon>
          <x-text ${css({ "font-size": "1em", color: this.colors.white })}
            >${this.isOnline ? this._translation.translate("connection-status-alert", "onlineAgain") : `${this._translation.translate("connection-status-alert", "offline")} 
                ${this._translation.translate("connection-status-alert", "checkConnection")}`}</x-text
          >
        </x-flex>
      `;
    }
  }
};
__decorateClass([
  property({ type: Boolean })
], XConnectionStatusAlert.prototype, "blocking", 2);
__decorateClass([
  property({ type: Number })
], XConnectionStatusAlert.prototype, "showDuration", 2);
__decorateClass([
  state()
], XConnectionStatusAlert.prototype, "isOnline", 2);
__decorateClass([
  state()
], XConnectionStatusAlert.prototype, "isShowing", 2);
__decorateClass([
  state()
], XConnectionStatusAlert.prototype, "enabled", 2);
__decorateClass([
  state()
], XConnectionStatusAlert.prototype, "_translation", 2);
XConnectionStatusAlert = __decorateClass([
  customElement("x-connection-status-alert")
], XConnectionStatusAlert);
export {
  XConnectionStatusAlert,
  enableConnectionStatusAlert
};
